import React from "react";
import "./Legend.css";

function Legend({
  legendContent,
}) {
  return (
    <div className="CommonLegend">
      {legendContent.map((item, index) => (
        <div key={index} className="CommonLegend__Content">
          {item.type === "circle" && <span style={item.circleStyle} />}
          {item.type === "text" && <span style={item.textStyle}>{`${item.textName}:`}</span>}
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
export default Legend;
